<template>
  <div class="gx-opt">
    <gx-loading :show="loading" />
    <div class="gx-opt__layout">
      <!-- 左侧导航 -->
      <!-- <aside class="gx-opt__sider">
        <div class="gx-opt__tabs">
          <button
            v-for="(t, i) in [
              { name: 'AI标题', desc: '智能生成高点击率标题', icon: '✏️' },
              { name: 'AI生成白底图', desc: '智能抠图合成白底', icon: '⬜' },
              { name: 'AI生成3/4图', desc: '多角度商品图生成', icon: '📐' },
              { name: 'AI生成视频', desc: '商品短视频一键生成', icon: '🎬' }
            ]"
            :key="i"
            class="gx-opt__tab"
            :class="{ 'gx-opt__tab--on': tab === i }"
            @click="switchMainTab(i)"
          >
            <span class="gx-opt__tab-icon">{{ t.icon }}</span>
            <span class="gx-opt__tab-body">
              <span class="gx-opt__tab-name">{{ t.name }}</span>
            </span>
          </button>
        </div>
      </aside> -->

      <!-- 右侧内容 -->
      <main class="gx-opt__main">
        <!-- ========== AI标题 ========== -->
        <div v-if="tab === 0">
          <div class="gx-opt__pane-head">
            <span class="gx-opt__pane-icon">✏️</span>
            <div class="gx-opt__pane-text">
              <span class="gx-opt__pane-title">{{ tabTitles[tab] }}</span>
              <span class="gx-opt__pane-desc">{{ tabDescs[tab] }}</span>
            </div>
          </div>
          <div class="gx-opt__seg">
            <button class="gx-opt__seg-btn" :class="{ 'gx-opt__seg-btn--on': titleSubTab === 'task' }" @click="switchTitleSub('task')">任务列表</button>
            <button class="gx-opt__seg-btn" :class="{ 'gx-opt__seg-btn--on': titleSubTab === 'detail' }" @click="switchTitleSub('detail')">替换详情</button>
          </div>

          <!-- 任务列表 -->
          <div v-if="titleSubTab === 'task'">
            <div class="gx-opt__filter">

              <div class="search-wrap custom-form-wrap">
                  <el-form inline size="mini" :model="titleSearch" ref="searchForm">
                    <el-form-item label="任务编号">
                        <el-input v-model="titleSearch.taskNo" placeholder="请输入任务编号" clearable></el-input>
                      </el-form-item>
                      <el-form-item label="状态">
                        <el-select v-model="titleSearch.status" clearable placeholder="全部" class="w200"  @change="handleTitleSearch">
                            <el-option v-for="label in titleStatusList" :key="label.value" :label="label.label" :value="label.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>

              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">任务编号</label>
                <input v-model="titleSearch.taskNo" class="gx-opt__input" placeholder="请输入任务编号" @keyup.enter="handleTitleSearch" />
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">状态</label>
                <select v-model="titleSearch.status" class="gx-opt__select" @change="handleTitleSearch">
                  <option value="">全部</option>
                  <option v-for="s in titleStatusList" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div> -->
              <div class="gx-opt__fitem gx-opt__fitem--btns">
                <button class="gx-opt__btn gx-opt__btn--primary" @click="handleTitleSearch">查询</button>
                <button class="gx-opt__btn" @click="refreshTitle">重置</button>
              </div>
            </div>
            <div class="gx-opt__actionrow">
              <button class="gx-opt__btn gx-opt__btn--primary" @click="handleCheck">AI生成标题</button>
              <el-tooltip content="AI标题生成后，自动裁剪前面填充至短标题中" placement="top">
                <i class="el-icon-info gx-opt__info-icon"></i>
              </el-tooltip>
            </div>
            <div class="gx-opt__table">
              <table>
                <thead>
                  <tr>
                    <th style="width: 36px"></th>
                    <th>序号</th>
                    <th>任务编号</th>
                    <th>商品分组</th>
                    <th>状态</th>
                    <th v-if="ismanager">AI提示词环境</th>
                    <th>创建时间</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in titleTaskList" :key="row.id">
                    <td>
                      <span class="gx-opt__check" :class="{ 'gx-opt__check--on': titleTaskSelected.includes(row) }" @click="toggleTaskSel(row)">
                        <svg v-if="titleTaskSelected.includes(row)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                      </span>
                    </td>
                    <td class="gx-opt__mono">{{ idx + 1 }}</td>
                    <td class="gx-opt__mono">{{ row.task_no }}</td>
                    <td>{{ getGroupNameText(row.group_ids, row.child_group_ids) }}</td>
                    <td><span class="gx-opt__status" :style="titleStatusStyle(row.status)">{{ row.status_name }}</span></td>
                    <td v-if="ismanager">{{ row.ai_method_name }}</td>
                    <td class="gx-opt__mono gx-opt__dim">{{ row.created_at }}</td>
                    <td>
                      <div class="gx-opt__ops">
                        <button v-if="row.status === 2" class="gx-opt__op" @click="handleStop(row)">停止</button>
                        <button class="gx-opt__op gx-opt__op--edit" @click="handleView(row)">查看</button>
                        <button class="gx-opt__op gx-opt__op--primary" :disabled="row.status <= 2" @click="handleUpdate(row)">替换</button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!titleTaskList.length">
                    <td :colspan="ismanager ? 8 : 7" class="gx-opt__empty">暂无任务</td>
                  </tr>
                </tbody>
              </table>
              <!-- 分页 -->
              <div class="gx-opt__pager" v-if="titlePage.total > 1">
                <Pagination :total="titlePage.total" :page.sync="titlePage.page" :limit.sync="titlePage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getTitleTaskList(titlePage.page)"  layout="total, sizes, prev, pager, next, jumper" />
              </div>
            </div>
          </div>

          <!-- 替换详情 -->
          <div v-else>
            <div class="gx-opt__filter">
                 <div class="search-wrap custom-form-wrap">
                  <el-form inline size="mini" :model="titleSearch" ref="searchForm">
                    <el-form-item label="任务编号">
                        <el-input v-model="titleSearch.taskNo" placeholder="请输入任务编号" clearable></el-input>
                      </el-form-item>
                      <el-form-item label="商品分组">
                        <el-select v-model="titleSearch.group_ids" clearable multiple placeholder="全部" class="w200"  @change="changeTitleGroupIds">
                            <el-option v-for="label in groupList" :key="label.id" :label="label.name" :value="label.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="商品子分组">
                        <el-select v-model="titleSearch.child_group_ids" clearable multiple placeholder="全部" class="w200"  @change="handleTitleSearch">
                            <el-option v-for="label in titleChildGroupList" :key="label.id" :label="label.name" :value="label.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="SKU替换状态">
                        <el-select v-model="titleSearch.sku_status" clearable placeholder="全部" class="w200"  @change="handleTitleSearch">
                            <el-option v-for="label in skuWays" :key="label.value" :label="label.label" :value="label.value"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="标题替换状态">
                        <el-select v-model="titleSearch.status" clearable placeholder="全部" class="w200"  @change="handleTitleSearch">
                            <el-option v-for="label in titleStatusList" :key="label.value" :label="label.label" :value="label.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>


              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">任务编号</label>
                <input v-model="titleSearch.taskNo" class="gx-opt__input" placeholder="请输入任务编号" @keyup.enter="handleTitleSearch" />
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">商品分组</label>
                <multi-select v-model="titleSearch.group_ids" :options="groupList" placeholder="全部" @input="changeTitleGroupIds" />
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">商品子分组</label>
                <multi-select v-model="titleSearch.child_group_ids" :options="titleChildGroupList" placeholder="全部" @input="handleTitleSearch" />
              </div> -->
              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">SKU替换状态</label>
                <select v-model="titleSearch.sku_status" class="gx-opt__select" @change="handleTitleSearch">
                  <option value="">全部</option>
                  <option v-for="s in skuWays" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">标题替换状态</label>
                <select v-model="titleSearch.status" class="gx-opt__select" @change="handleTitleSearch">
                  <option value="">全部</option>
                  <option v-for="s in titleStatusList" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div> -->
              <div class="gx-opt__fitem gx-opt__fitem--btns">
                <button class="gx-opt__btn gx-opt__btn--primary" @click="handleTitleSearch">查询</button>
                <button class="gx-opt__btn" @click="refreshTitle">重置</button>
              </div>
            </div>
            <div class="gx-opt__table">
              <table>
                <thead>
                  <tr>
                    <th style="width: 36px"></th>
                    <th>序号</th>
                    <th>分组|子分组</th>
                    <th>商品信息</th>
                    <th>状态</th>
                    <th v-if="ismanager">错误信息</th>
                    <th v-if="ismanager">AI提示词环境</th>
                    <th>创建时间</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in titleDetailList" :key="row.id">
                    <td>
                      <span class="gx-opt__check" :class="{ 'gx-opt__check--on': titleDetailSelected.includes(row) }" @click="toggleDetailSel(row)">
                        <svg v-if="titleDetailSelected.includes(row)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                      </span>
                    </td>
                    <td class="gx-opt__mono">{{ idx + 1 }}</td>
                    <td>
                      <template>
                        <div class="gx-cloud__gname" :title="formatGroupName(row).split('|')[0]">{{ formatGroupName(row).split('|')[0] }}</div>
                        <div v-if="formatGroupName(row).split('|')[1]" class="gx-cloud__gname gx-cloud__gname--sub" :title="formatGroupName(row).split('|')[1]">{{ formatGroupName(row).split('|')[1] }}</div>
                      </template>
                    </td>
                    <td>
                      <div class="gx-opt__goods">
                        <el-popover
                            placement="top"
                            :fallback-placements="[ 'top', 'right', 'left','bottom']"
                            width="350"
                            trigger="hover" :disabled="!row.image">
                          <div class="popover-content">
                            <el-image :src="row.image" fit="contain" style="width:100%;height: auto"></el-image>
                          </div>
                          <span slot="reference" class="gx-opt__thumb"><img v-if="row.image" :src="row.image" alt="" /><span v-else>🛍️</span></span>
                        </el-popover>

                        <div class="gx-opt__goods-body">
                          <div class="gx-opt__line"><span class="gx-opt__label">商品ID：</span><span class="gx-opt__mono">{{ row.product_id }}</span></div>
                          <div class="gx-opt__line"><span class="gx-opt__label">原：</span><span class="gx-opt__txt">{{ row.title }}</span></div>
                          <div class="gx-opt__line"><span class="gx-opt__label">AI：</span><span class="gx-opt__txt gx-opt__txt--ai">{{ row.new_title }}</span></div>
                          <div class="gx-opt__line" v-if="row.update_title"><span class="gx-opt__label">改：</span><span class="gx-opt__txt">{{ row.update_title }}</span></div>
                          <div class="gx-opt__line" v-if="row.status !== 1 && row.status !== 2">
                            <span class="gx-opt__label">修改：</span>
                            <input v-model="row.edit_title" class="gx-opt__input gx-opt__input--flex" placeholder="在这里输入新标题" maxlength="60" />
                            <button class="gx-opt__op gx-opt__op--primary" :disabled="aiTitleUpdateLoading" @click="saveEditTitle(row)">修改</button>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td><span class="gx-opt__status" :style="titleStatusStyle(row.status)">{{ row.status_name }}</span></td>
                    <td v-if="ismanager" class="gx-opt__err" :title="row.error_msg">{{ row.error_msg || '-' }}</td>
                    <td v-if="ismanager">{{ row.ai_method_name }}</td>
                    <td class="gx-opt__mono gx-opt__dim">{{ row.created_at }}</td>
                  </tr>
                  <tr v-if="!titleDetailList.length">
                    <td :colspan="ismanager ? 8 : 6" class="gx-opt__empty">暂无替换详情</td>
                  </tr>
                </tbody>
              </table>

              <div class="gx-opt__pager" v-if="titlePage.total > 1">
                <Pagination :total="titlePage.total" :page.sync="titlePage.page" :limit.sync="titlePage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getTitleDetailList(titlePage.page)"  layout="total, sizes, prev, pager, next, jumper" />
              </div>
            </div>
          </div>
        </div>

        <!-- ========== AI生成图片 / 视频 ========== -->
        <div v-else>
          <div class="gx-opt__pane-head">
            <span class="gx-opt__pane-icon">
              <span v-if="tab === 1">⬜</span>
              <span v-else-if="tab === 2">📐</span>
              <span v-else>🎬</span>
            </span>
            <div class="gx-opt__pane-text">
              <span class="gx-opt__pane-title">{{ tabTitles[tab] }}</span>
              <span class="gx-opt__pane-desc">{{ tabDescs[tab] }}</span>
            </div>
          </div>
          <div class="gx-opt__seg">
            <button class="gx-opt__seg-btn" :class="{ 'gx-opt__seg-btn--on': imgSubTab === 'goods' }" @click="switchImgSub('goods')">商品列表</button>
            <button class="gx-opt__seg-btn" :class="{ 'gx-opt__seg-btn--on': imgSubTab === 'task' }" @click="switchImgSub('task')">任务列表</button>
          </div>

          <!-- 商品列表 -->
          <div v-if="imgSubTab === 'goods'">
            <div class="gx-opt__filter">

              <div class="search-wrap custom-form-wrap">
                  <el-form inline size="mini" :model="imgSearch" ref="searchForm">
                      <el-form-item label="商品分组">
                        <el-select v-model="imgSearch.group_id" clearable placeholder="全部" class="w200"  @change="changeImgGroupId">
                            <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="商品子分组">
                        <el-select v-model="imgSearch.child_group_id" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                            <el-option v-for="g in imgChildGroupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :label="`${targetDirectionName}状态`">
                        <el-select v-model="imgSearch[statusKey]" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                            <el-option v-for="w in imageWays" :key="w.value" :label="w.label" :value="w.value"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="SKU替换状态">
                        <el-select v-model="imgSearch.sku_status" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                            <el-option v-for="s in skuWays" :key="s.value" :label="s.label" :value="s.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>


              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">商品分组</label>
                <select v-model="imgSearch.group_id" class="gx-opt__select" @change="changeImgGroupId">
                  <option value="">全部</option>
                  <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                </select>
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">商品子分组</label>
                <select v-model="imgSearch.child_group_id" class="gx-opt__select" @change="handleImgSearch">
                  <option value="">全部</option>
                  <option v-for="g in imgChildGroupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                </select>
              </div> -->
              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">{{ targetDirectionName }}状态</label>
                <select v-model="imgSearch[statusKey]" class="gx-opt__select" @change="handleImgSearch">
                  <option value="">全部</option>
                  <option v-for="w in imageWays" :key="w.value" :value="w.value">{{ w.label }}</option>
                </select>
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">SKU替换状态</label>
                <select v-model="imgSearch.sku_status" class="gx-opt__select" @change="handleImgSearch">
                  <option value="">全部</option>
                  <option v-for="s in skuWays" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div> -->
              <div class="gx-opt__fitem gx-opt__fitem--btns">
                <button class="gx-opt__btn gx-opt__btn--primary" @click="handleImgSearch">查询</button>
                <button class="gx-opt__btn" @click="refreshImg">重置</button>
              </div>
            </div>
            <div class="gx-opt__actionrow">
              <button class="gx-opt__btn gx-opt__btn--primary" @click="handleImgCheck">AI生成{{ targetDirectionName }}</button>
            </div>
            <div class="gx-opt__table">
              <table>
                <thead>
                  <tr>
                    <th style="width: 36px">
                      <span class="gx-opt__check" :class="{ 'gx-opt__check--on': imgAllChecked }" @click="toggleImgAll">
                        <svg v-if="imgAllChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                      </span>
                    </th>
                    <th>上新时间</th>
                    <th>商品来源</th>
                    <th>分组</th>
                    <th>商品信息</th>
                    <th>{{ targetDirectionName }}状态</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in imgGoodsList" :key="row.id">
                    <td>
                      <span class="gx-opt__check" :class="{ 'gx-opt__check--on': imgSelected.includes(row.product_id) }" @click="toggleImgSel(row.product_id)">
                        <svg v-if="imgSelected.includes(row.product_id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                      </span>
                    </td>
                    <td class="gx-opt__mono gx-opt__dim">{{ row.created_at_text }}</td>
                    <td><span class="gx-opt__src" :class="sourceCls(row.source_web)">{{ sourceMap?.[row.source_web]?.label??'未知' }}</span></td>
                    <td>
                      <template>
                        <div class="gx-cloud__gname" :title="formatGroupName(row).split('|')[0]">{{ formatGroupName(row).split('|')[0] }}</div>
                        <div v-if="formatGroupName(row).split('|')[1]" class="gx-cloud__gname gx-cloud__gname--sub" :title="formatGroupName(row).split('|')[1]">{{ formatGroupName(row).split('|')[1] }}</div>
                      </template>
                    </td>
                    <td>
                      <div class="gx-opt__goods">
                        <el-popover
                            placement="top"
                            :fallback-placements="[ 'top', 'right', 'left','bottom']"
                            width="350"
                            trigger="hover" :disabled="!row.main_image">
                          <div class="popover-content">
                            <el-image :src="row.main_image" fit="contain" style="width:100%;height: auto"></el-image>
                          </div>
                          <span slot="reference" class="gx-opt__thumb"><img v-if="row.main_image" :src="row.main_image" alt="" /><span v-else>🛍️</span></span>
                        </el-popover>

                        <div class="gx-opt__goods-body">
                          <div class="gx-opt__line"><span class="gx-opt__mono gx-opt__txt--ai" style="color: rgb(153, 153, 153);">{{ row.source_product_id }}</span></div>
                          <div class="gx-opt__line"><span class="gx-opt__txt" :title="row.title">{{ row.title }}</span></div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="gx-opt__statuscell">
                        <span class="gx-opt__img-status" :class="imgStatusCls(row)">{{ getImageStatusText(row) }}</span>
                        <button v-if="row[statusKey] === 3 && !isImageExpire(row)" class="gx-opt__op gx-opt__op--primary" @click="handleViewImg(row)">查看效果</button>
                      </div>
                    </td>
                    <td>
                      <button class="gx-opt__op gx-opt__op--edit" @click="handleEdit(row)">编辑商品</button>
                    </td>
                  </tr>
                  <tr v-if="!imgGoodsList.length">
                    <td :colspan="7" class="gx-opt__empty">暂无商品</td>
                  </tr>
                </tbody>
              </table>

              <div class="gx-opt__pager" v-if="imgPage.total > 1">
              <Pagination :total="imgPage.total" :page.sync="imgPage.page" :limit.sync="imgPage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getImgGoodsList(imgPage.page)"  layout="total, sizes, prev, pager, next, jumper" />
            </div>
            </div>
          </div>

          <!-- 任务列表 -->
          <div v-else>
            <div class="gx-opt__filter">

               <div class="search-wrap custom-form-wrap">
                  <el-form inline size="mini" :model="imgTaskSearch" ref="searchForm">
                      <el-form-item label="任务编号">
                        <el-input v-model="imgTaskSearch.task_no" clearable placeholder="全部" @change="changeImgGroupId"></el-input>
                      </el-form-item>
                      <el-form-item label="状态">
                        <el-select v-model="imgTaskSearch.status" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                            <el-option v-for="s in imgTaskStatusList" :key="s.value" :label="s.label" :value="s.value"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="SKU状态">
                        <el-select v-model="imgTaskSearch.sku_status" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                            <el-option v-for="w in skuWays" :key="w.value" :label="w.label" :value="w.value"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="处理方式">
                        <el-select v-model="imgTaskSearch.process_direction" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                            <el-option v-for="c in imgCheckWays" :key="c.value" :label="c.label" :value="c.value"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="创建时间">
                        <el-date-picker class="w320"
                            v-model="imgTaskSearch.create_time"
                            type="datetimerange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions"
                             @change="handleImgSearch"
                            :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                      </el-form-item>
                    </el-form>
                  </div>

              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">任务编号</label>
                <input v-model="imgTaskSearch.task_no" class="gx-opt__input" placeholder="请输入" @keyup.enter="handleImgSearch" />
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">状态</label>
                <select v-model="imgTaskSearch.status" class="gx-opt__select" @change="handleImgSearch">
                  <option value="">全部</option>
                  <option v-for="s in imgTaskStatusList" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div> -->
              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">SKU状态</label>
                <select v-model="imgTaskSearch.sku_status" class="gx-opt__select" @change="handleImgSearch">
                  <option value="">全部</option>
                  <option v-for="s in skuWays" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div>
              <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">处理方式</label>
                <select v-model="imgTaskSearch.process_direction" class="gx-opt__select" @change="handleImgSearch">
                  <option value="">全部</option>
                  <option v-for="c in imgCheckWays" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div> -->
              <!-- <div class="gx-opt__fitem">
                <label class="gx-opt__flabel">创建时间</label>
                <input v-model="imgTaskSearch.start_time" type="datetime-local" class="gx-opt__input gx-opt__input--date" />
                <span class="gx-opt__range-sep">至</span>
                <input v-model="imgTaskSearch.end_time" type="datetime-local" class="gx-opt__input gx-opt__input--date" />
              </div> -->
              <div class="gx-opt__fitem gx-opt__fitem--btns">
                <button class="gx-opt__btn gx-opt__btn--primary" @click="handleImgSearch">查询</button>
                <button class="gx-opt__btn" @click="refreshImg">重置</button>
              </div>
            </div>
            <div class="gx-opt__table">
              <table>
                <thead>
                  <tr>
                    <th>任务编号</th>
                    <th>处理方式</th>
                    <th>生成目标</th>
                    <th>指定主图素材</th>
                    <th>数量</th>
                    <th>状态</th>
                    <th>SKU状态</th>
                    <th>时间</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in imgTaskList" :key="row.id">
                    <td class="gx-opt__mono">{{ row.task_no }}</td>
                    <td>{{ checkMap[row.process_direction] ? checkMap[row.process_direction].label : '' }}</td>
                    <td>{{row.target_direction==1?'AI':''}}{{ targetDirectionMap[row.target_direction] }}</td>
                    <td>{{materialsMap?.[row.specify_materials]?.label??''}}<span style="color: #999;" v-if="[4,5].includes(row.specify_materials)">（如无则默认最后一张）</span></td>
                    <td class="gx-opt__counts">
                      <div>商品数：<b>{{ row.product_total_count || 0 }}</b></div>
                      <div>成功数：<b class="gx-opt__ok">{{ row.product_success_count || 0 }}</b></div>
                      <div>失败数：<b class="gx-opt__fail">{{ row.product_failed_count || 0 }}</b></div>
                      <div>消耗算力：<b>{{ row.use_power_num || 0 }}</b></div>
                    </td>
                    <td><span class="gx-opt__status" :style="imgTaskStatusStyle(row.status)">{{ row.status_name }}</span></td>
                    <td><span class="gx-opt__status" :style="imgTaskSkuStatusStyle(row.sku_status)" v-if="row.sku_status>0">{{ skuStatusMap[row.sku_status] ? skuStatusMap[row.sku_status].label : '' }}</span></td>
                    <td class="gx-opt__time">
                      <div>创建：{{ row.created_at }}</div>
                      <div>更新：{{ row.updated_at }}</div>
                    </td>
                    <td>
                      <div class="gx-opt__ops">
                        <button class="gx-opt__op gx-opt__op--edit" @click="handleViewTask(row)">查看</button>
                        <button v-if="['1', '2', '5'].includes(String(row.status))" class="gx-opt__op gx-opt__op--danger" @click="handleCancel(row)">取消</button>
                        <button v-if="['1', '2'].includes(String(row.status))" class="gx-opt__op" @click="handlePause(row)">暂停</button>
                        <button v-if="row.status == 5" class="gx-opt__op gx-opt__op--recover" @click="handleStart(row)">启动</button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!imgTaskList.length">
                    <td :colspan="8" class="gx-opt__empty">暂无任务</td>
                  </tr>
                </tbody>
              </table>
              <div class="gx-opt__pager" v-if="imgPage.total > 1">
                <Pagination :total="imgPage.total" :page.sync="imgPage.page" :limit.sync="imgPage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getImgTaskList(imgPage.page)"  layout="total, sizes, prev, pager, next, jumper" />
              </div>
            </div>
          </div>
        </div>
      </main>
    <!-- 弹窗：AI生成标题 -->
    <div v-if="aiTitleFormShow" class="gx-opt__modal" @click.self="aiTitleFormShow = false">
      <div class="gx-opt__modal-box">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">AI生成标题</span>
          <button class="gx-opt__modal-close" @click="aiTitleFormShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <div class="gx-opt__field">
            <label class="gx-opt__label">选择商品分组</label>
            <multi-select v-model="aiTitleForm.group_ids" :options="groupList" placeholder="全部" @input="changeTitleFormGroupIds" />
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">选择商品子分组</label>
            <multi-select v-model="aiTitleForm.child_group_ids" :options="titleFormChildGroupList" placeholder="全部" />
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">过滤违规词分组（检测管理-&gt;关键词检测配置）</label>
            <multi-select v-model="aiTitleForm.lexicon_types" :options="dictionaryWordsList" placeholder="全部" />
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">SKU替换状态</label>
            <select v-model="aiTitleForm.sku_status" class="gx-opt__select gx-opt__select--full">
              <option value="">全部</option>
              <option v-for="s in skuWays" :key="s.value" :value="s.value">{{ s.label }}</option>
            </select>
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">需要生成标题商品 <i class="gx-opt__req">*</i></label>
            <select v-model="aiTitleForm.data_method" class="gx-opt__select gx-opt__select--full">
              <option v-for="c in checkWays" :key="c.value" :value="c.value">{{ c.label }}</option>
            </select>
          </div>
          <div class="gx-opt__field" v-if="ismanager">
            <label class="gx-opt__label">AI提示词 <i class="gx-opt__req">*</i></label>
            <select v-model="aiTitleForm.ai_method" class="gx-opt__select gx-opt__select--full">
              <option v-for="a in aiWays" :key="a.value" :value="a.value">{{ a.label }}</option>
            </select>
          </div>
        </div>
        <div class="gx-opt__modal-foot">
          <span class="gx-opt__warn">选择商品不要超过1万，使用过程会消耗算力。</span>
          <button class="gx-opt__btn" @click="aiTitleFormShow = false">取消</button>
          <button class="gx-opt__btn gx-opt__btn--primary" :disabled="submitFormLoading" @click="submitForm">
            {{ submitFormLoading ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：替换标题 -->
    <div v-if="aiTitleUpdateShow" class="gx-opt__modal" @click.self="aiTitleUpdateShow = false">
      <div class="gx-opt__modal-box gx-opt__modal-box--sm">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">替换标题</span>
          <button class="gx-opt__modal-close" @click="aiTitleUpdateShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <div class="gx-opt__field">
            <label class="gx-opt__label">标题前缀</label>
            <input v-model="aiTitleUpdateForm.before_word" class="gx-opt__input gx-opt__input--full" placeholder="请输入标题前缀" />
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">待替换词（多关键词逗号分割，例如（2025，2024，纯棉）） <i class="gx-opt__req">*</i></label>
            <input v-model="aiTitleUpdateForm.old_word" class="gx-opt__input gx-opt__input--full" placeholder="请输入待替换词" />
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">替换词（多关键词逗号分割，（例如2026，2026，棉）） <i class="gx-opt__req">*</i></label>
            <input v-model="aiTitleUpdateForm.new_word" class="gx-opt__input gx-opt__input--full" placeholder="请输入替换词" />
          </div>
        </div>
        <div class="gx-opt__modal-foot">
          <button class="gx-opt__btn" @click="aiTitleUpdateShow = false">取消</button>
          <button class="gx-opt__btn gx-opt__btn--primary" :disabled="aiTitleUpdateLoading" @click="submitUpdateForm">
            {{ aiTitleUpdateLoading ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：生成图片/视频 -->
    <div v-if="aiFormShow" class="gx-opt__modal" @click.self="aiFormShow = false">
      <div class="gx-opt__modal-box">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">生成{{ targetDirectionName }}</span>
          <button class="gx-opt__modal-close" @click="aiFormShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <div class="gx-opt__field" v-if="imgSelected.length">
            <label class="gx-opt__label">已选商品：</label>
            <span class="gx-opt__gold">{{ imgSelected.length }}</span> 个
          </div>
          <template v-if="targetDirection===1">
            <!-- <div class="gx-opt__field">
              <label class="gx-opt__label">使用主图 <i class="gx-opt__req">*</i></label>
              <el-radio-group v-model="aiForm.specify_materials" class="radio-box">
                <el-radio v-for="item in materialsList" :label="item.value" :key="item.value">{{ item.label }}
                  <span style="color: #f42c2c;" v-if="item.value===9">（推荐）</span>
                  <span style="color: #999;" v-if="item.value===4||item.value===5">（如无则默认最后一张）</span>
                </el-radio>
              </el-radio-group>
            </div> -->
            <div class="gx-opt__field">
              <label class="gx-opt__label">使用主图</label>
              <select v-model="aiForm.specify_materials" class="gx-opt__select gx-opt__select--full">
                <option v-for="s in materialsList" :key="s.value" :value="s.value">{{ s.label }}{{ s.value===9?'（推荐）':(s.value===4||s.value===5)?'（如无则默认最后一张）':'' }}</option>
              </select>
          </div>
            <div class="gx-opt__field">
              <label class="gx-opt__label">生成模式 <i class="gx-opt__req">*</i></label>
              <el-radio-group v-model="aiForm.target_direction" class="radio-box">
                <el-radio :label="1">
                  AI白底图
                  <el-tooltip placement="top" popper-class="gx-opt__fee-popper" :content="'普通会员10 算力/张\n企业版会员5 算力/张'">
                    <i class="el-icon-question gx-opt__fee-tip" @click.stop></i>
                  </el-tooltip>
                </el-radio>
                <el-radio :label="4">
                  常规白底图
                  <el-tooltip placement="top" popper-class="gx-opt__fee-popper" :content="'普通会员0.1 算力/个\n企业版会员0.1 算力/个'">
                    <i class="el-icon-question gx-opt__fee-tip" @click.stop></i>
                  </el-tooltip>
                </el-radio>
              </el-radio-group>
            </div>
          </template>
          <div class="power-tip" :class="{'m-t-10':targetDirection===1}">
            <!-- <template v-if="targetDirection===1">
              AI白底图：单张费用 <strong>{{powerFee[5]||''}}</strong> 算力<br/>常规白底图：单张费用 <strong>{{powerFee[10]||''}}</strong> 算力，生成效果不能保证达标率
            </template> -->
            <!-- <template v-if="targetDirection===2">
              AI3/4图：单商品费用 <strong>{{powerFee[6]||''}}</strong> 算力
            </template> -->
            <!-- <template v-if="targetDirection===3">
              AI视频：单商品费用 <strong>{{powerFee[7]||''}}</strong> 算力
            </template> -->
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">需要生成图片商品 <i class="gx-opt__req">*</i></label>
            <select v-model="aiForm.process_direction" class="gx-opt__select gx-opt__select--full">
              <option value="">请选择</option>
              <option v-for="c in imgCheckWays" :key="c.value" :value="c.value">{{ c.label }}</option>
            </select>
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">商品分组</label>
            <multi-select v-model="aiForm.group_ids" :options="groupList" placeholder="全部" @input="changeImgFormGroupIds" />
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">商品子分组</label>
            <multi-select v-model="aiForm.child_group_ids" :options="imgFormChildGroupList" placeholder="全部" />
          </div>
          <div class="gx-opt__field">
            <label class="gx-opt__label">SKU替换状态</label>
            <select v-model="aiForm.sku_status" class="gx-opt__select gx-opt__select--full">
              <option value="">全部</option>
              <option v-for="s in skuWays" :key="s.value" :value="s.value">{{ s.label }}</option>
            </select>
          </div>
        </div>
        <div class="gx-opt__modal-foot">
          <span class="gx-opt__warn">选择商品不要超过1万，使用过程会消耗算力。</span>
          <button class="gx-opt__btn" @click="aiFormShow = false">取消</button>
          <button class="gx-opt__btn gx-opt__btn--primary" :disabled="submitFormLoading" @click="checkTaskPower">
            {{ submitFormLoading ? '计算中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：所需算力明细 -->
    <div v-if="powerShow" class="gx-opt__modal" @click.self="powerShow = false">
      <div class="gx-opt__modal-box gx-opt__modal-box--sm">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">所需算力明细</span>
          <button class="gx-opt__modal-close" @click="powerShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <div class="gx-opt__power-row"><span class="gx-opt__dim">当前算力：</span><b>{{ powerInfo.current_power_num || 0 }}</b></div>
          <div class="gx-opt__power-row"><span class="gx-opt__dim">预计消耗：</span><b>{{ powerInfo.required_power_num || 0 }}</b></div>
          <div class="gx-opt__power-row"><span class="gx-opt__dim">符合条件的商品数：</span><b>{{ powerInfo.product_count || 0 }}</b></div>
          <div class="gx-opt__power-row">
            <span class="gx-opt__dim">是否充足：</span>
            <span class="gx-opt__tag" :class="powerInfo.is_sufficient ? 'gx-opt__tag--ok' : 'gx-opt__tag--fail'">{{ powerInfo.is_sufficient ? '是' : '否' }}</span>
          </div>
        </div>
        <div class="gx-opt__modal-foot">
          <button class="gx-opt__btn" @click="powerShow = false">取消</button>
          <button class="gx-opt__btn gx-opt__btn--primary" :disabled="checkFormLoading" @click="submitImgForm">
            {{ checkFormLoading ? '生成中...' : '确定生成' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：任务详情 -->
    <div v-if="taskDetailShow" class="gx-opt__modal gx-opt__modal--wide" @click.self="taskDetailShow = false">
      <div class="gx-opt__modal-box gx-opt__modal-box--xl">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">任务 - {{ detailSearchParams.task_no }}</span>
          <button class="gx-opt__modal-close" @click="taskDetailShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <div class="gx-opt__filter">

            <div class="search-wrap custom-form-wrap">
              <el-form inline size="mini" :model="detailSearchParams" ref="searchForm">
                  <el-form-item label="商品ID">
                    <el-input v-model="detailSearchParams.product_id" clearable placeholder="请输入商品ID"></el-input>
                  </el-form-item>
                  <el-form-item label="状态">
                    <el-select v-model="detailSearchParams.status" clearable placeholder="全部" class="w200" style="width: 150px;" @change="handleSearchDetail">
                        <el-option v-for="s in detailStatusList" :key="s.value" :label="s.label" :value="s.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="创建时间">
                    <el-date-picker class="w320"
                        v-model="detailSearchParams.create_time"
                        type="datetimerange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                         @change="handleSearchDetail"
                        :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
              </div>


            <!-- <div class="gx-opt__fitem">
              <label class="gx-opt__flabel">商品ID</label>
              <input v-model="detailSearchParams.product_id" class="gx-opt__input" placeholder="请输入商品ID" @keyup.enter="handleSearchDetail" />
            </div>
            <div class="gx-opt__fitem">
              <label class="gx-opt__flabel">状态</label>
              <select v-model="detailSearchParams.status" class="gx-opt__select" @change="handleSearchDetail">
                <option value="">全部</option>
                <option v-for="s in detailStatusList" :key="s.value" :value="s.value">{{ s.label }}</option>
              </select>
            </div>
            <div class="gx-opt__fitem">
              <label class="gx-opt__flabel">创建时间</label>
              <input v-model="detailSearchParams.start_time" type="datetime-local" class="gx-opt__input gx-opt__input--date" />
              <span class="gx-opt__range-sep">至</span>
              <input v-model="detailSearchParams.end_time" type="datetime-local" class="gx-opt__input gx-opt__input--date" />
            </div> -->
            <div class="gx-opt__fitem gx-opt__fitem--btns">
              <button class="gx-opt__btn gx-opt__btn--primary" @click="handleSearchDetail">查询</button>
              <button class="gx-opt__btn" @click="refreshDetail">重置</button>
            </div>
          </div>
          <div class="gx-opt__stats">
            商品数：<b>{{ detailStatistics.product_count || 0 }}</b> |
            成功数：<b class="gx-opt__ok">{{ detailStatistics.success_count || 0 }}</b> |
            失败数：<b class="gx-opt__fail">{{ detailStatistics.failed_count || 0 }}</b> |
            使用算力：<b>{{ detailStatistics.use_power_num || 0 }}</b>
          </div>
          <div class="gx-opt__table gx-opt__table--plain">
            <table>
              <thead>
                <tr>
                  <th>商品ID</th>
                  <th>商品</th>
                  <th>成功数</th>
                  <th>失败数</th>
                  <th>使用算力</th>
                  <th>状态</th>
                  <th>创建时间</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in detailTableData" :key="row.id">
                  <td class="gx-opt__mono">{{ row.product_id }}</td>
                  <td>
                    <el-popover
                        placement="top"
                        :fallback-placements="[ 'top', 'right', 'left','bottom']"
                        width="350"
                        trigger="hover" :disabled="!row.pending_contents||!row.pending_contents[0]">
                      <div class="popover-content">
                        <el-image :src="row.pending_contents[0]" fit="contain" style="width:100%;height: auto"></el-image>
                      </div>
                      <span slot="reference" class="gx-opt__thumb gx-opt__thumb--sm" @click="previewImage(row.pending_contents)">
                        <img v-if="row.pending_contents && row.pending_contents[0]" :src="row.pending_contents[0]" alt="" />
                        <span v-else>🛍️</span>
                    </span>
                    </el-popover>
                  </td>
                  <td class="gx-opt__ok">{{ row.success_count }}</td>
                  <td class="gx-opt__fail">{{ row.failed_count }}</td>
                  <td class="gx-opt__mono">{{ row.use_power_num }}</td>
                  <td><span class="gx-opt__status" :style="detailStatusStyle(row.status)">{{ row.status_name }}</span></td>
                  <td class="gx-opt__mono gx-opt__dim">{{ row.created_at }}</td>
                  <td>
                    <button v-if="row.status == 3" class="gx-opt__op gx-opt__op--primary" @click="previewProcessed(row)">查看效果</button>
                  </td>
                </tr>
                <tr v-if="!detailTableData.length">
                  <td :colspan="8" class="gx-opt__empty">暂无明细</td>
                </tr>
              </tbody>
            </table>

            <div class="gx-opt__pager" v-if="detailPage.total > 1">
          <Pagination :total="detailPage.total" :page.sync="detailPage.page" :limit.sync="detailPage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getTaskDetailList(detailPage.page)"  layout="total, sizes, prev, pager, next, jumper" />
        </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：图片预览 -->
    <div v-if="imagesShow" class="gx-opt__modal" @click.self="imagesShow = false">
      <div class="gx-opt__modal-box gx-opt__modal-box--lg">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">{{ isEffectImg ? targetDirectionName : '商品图' }}</span>
          <button class="gx-opt__modal-close" @click="imagesShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <div class="gx-opt__img-list">
            <span v-for="(item, i) in imageUrlList" :key="i" class="gx-opt__img-item" :class="{ 'gx-opt__img-item--34': isEffectImg && targetDirection === 2 }" @click="previewSingle(item)">
              <img :src="item" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：视频预览 -->
    <div v-if="videoPreviewShow" class="gx-opt__modal" @click.self="videoPreviewShow = false">
      <div class="gx-opt__modal-box gx-opt__modal-box--lg">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">视频效果</span>
          <button class="gx-opt__modal-close" @click="videoPreviewShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <video v-if="videoUrl" ref="previewVideoPlayer" :src="videoUrl" class="gx-opt__video" controls autoplay @error="handleVideoError">
            您的浏览器不支持视频播放。
          </video>
        </div>
      </div>
    </div>

    <!-- 弹窗：单图大图预览 -->
    <div v-if="singleImgShow" class="gx-opt__modal" @click.self="singleImgShow = false">
      <div class="gx-opt__modal-box gx-opt__modal-box--lg">
        <div class="gx-opt__modal-head">
          <span class="gx-opt__modal-title">图片预览</span>
          <button class="gx-opt__modal-close" @click="singleImgShow = false">✕</button>
        </div>
        <div class="gx-opt__modal-body">
          <img :src="singleImgUrl" class="gx-opt__single-img" alt="" />
        </div>
      </div>
    </div>

    <!-- 编辑商品弹窗（复用原版组件） -->
    <edit-dialog
      :visible.sync="cloudEditShow"
      :cloud-edit-mode="cloudEditMode"
      :cloud-edit-list="cloudEditList"
      :cloud-edit-source-list="cloudEditSourceList"
    />

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import EditDialog from '../uc_optimization/edit/editDialog.vue'
import MultiSelect from './MultiSelect.vue'
import Pagination from '../../components/newUi/Pagination.vue'



export default {
  name: 'NewCloudOptimizePage',
  components: { EditDialog, MultiSelect, GxLoading, PageSizeSelect, Pagination },
  mixins: [gxLoading],
  props: {
    activeTab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tab: 0,
      tabTitles: ['AI标题（去品牌化）', 'AI生成白底图', 'AI生成3/4图', 'AI生成视频'],
      tabDescs: ['去品牌化智能生成', '智能生成纯白底商品图片', '智能生成3/4角度商品图片', '基于商品素材生成展示视频'],
      ismanager: false,
      groupList: [],
      groupLoading: false,
      // AI标题
      titleSubTab: 'task',
      titleTaskList: [],
      titleDetailList: [],
      titlePage: { limit: 10, page: 1, total: 0 },
      titlePageSizeOptions: [10, 20, 50, 100, 200, 500, 1000],
      titleSearch: { status: '', taskNo: '', sku_status: '', group_ids: [], child_group_ids: [] },
      titleTaskSelected: [],
      titleDetailSelected: [],
      titleChildGroupList: [],
      titleStatusList: [
        { label: '待处理', value: 1 }, { label: '处理中', value: 2 }, { label: '处理完成', value: 3 },
        { label: '已取消', value: 4 }, { label: '异常', value: 9 }
      ],
      aiTitleFormShow: false,
      aiTitleForm: { group_ids: [], child_group_ids: [], lexicon_types: [], data_method: 1, ai_method: 1, sku_status: '' },
      titleFormChildGroupList: [],
      aiTitleUpdateShow: false,
      aiTitleUpdateLoading: false,
      aiTitleUpdateForm: { id: '', old_word: '', new_word: '', before_word: '', after_word: '' },
      dictionaryWordsList: [],
      checkWays: [{ label: '未生成AI标题商品', value: 2 }, { label: '全部商品', value: 1 }],
      skuWays: [{ label: '未替换', value: 1 }, { label: '已替换', value: 2 }, { label: '找不到', value: 3 }],
      aiWays: [{ label: '正式AI提示词', value: 1 }, { label: '测试AI提示词', value: 2 }],
      sourceMap:{
        2:{label: '1688'},
        3:{label: 'TB'},
        4:{label: 'PDD'},
        5:{label: 'DY'},
        6:{label: 'WX'},
        9:{label: '星好货'}
      },
      // AI图片
      targetDirection: 1,
      imgSubTab: 'goods',
      imgGoodsList: [],
      imgTaskList: [],
      imgPage: { limit: 20, page: 1, total: 0 },
      imgPageSizeOptions: [10, 20, 50, 100, 200, 500, 1000],
      imgSearch: { status: 1, sku_status: '', group_id: '', child_group_id: '' },
      imgTaskSearch: { status: '', task_no: '', target_direction: 1, process_direction: '', sku_status: '', create_time: '' },
      imgSelected: [],
      imgChildGroupList: [],
      imageWays: [{ label: '未生成', value: 1 }, { label: '生成中', value: 2 }, { label: '已生成', value: 3 }, { label: '已过期', value: 4 }],
      imgTaskStatusList: [
        { label: '待处理', value: 1 }, { label: '处理中', value: 2 }, { label: '已完成', value: 3 },
        { label: '已取消', value: 4 }, { label: '暂停', value: 5 }, { label: '异常', value: 9 }
      ],
      targetDirectionMap: { 1: '白底图', 2: '3/4图片', 3: '视频',4:'常规白底图' },
      aiFormShow: false,
      aiForm: {group_ids: [],child_group_ids: [],product_ids:[], sku_status: '',process_direction: '',target_direction: 1,target_quantity: '' },
      imgFormChildGroupList: [],
      submitFormLoading: false,
      powerShow: false,
      powerInfo: {},
      checkFormLoading: false,
      // 任务详情
      taskDetailShow: false,
      detailSearchParams: { task_id: '', task_no: '', product_id: '', status: '', create_time: '' },
      detailPage: { page: 1, limit: 20, total: 0 },
      detailTableData: [],
      detailStatistics: {},
      detailStatusList: [
        { label: '待处理', value: 1 }, { label: '处理中', value: 2 }, { label: '已完成', value: 3 },
        { label: '已取消', value: 4 }, { label: '异常', value: 5 }
      ],
      // 预览
      imagesShow: false,
      isEffectImg: false,
      imageUrlList: [],
      singleImgShow: false,
      singleImgUrl: '',
      videoUrl: '',
      videoPreviewShow: false,
      // 编辑
      cloudEditShow: false,
      cloudEditMode: 'single',
      cloudEditList: [],
      cloudEditSourceList: [],
      powerFee:{},
      materialsList:[{label: '最后一张', value: 9},{label: '第一张', value: 1}, {label: '第二张', value: 2}, {label: '第三张', value: 3}, {label: '第四张', value: 4}, {label: '第五张', value: 5}],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  watch: {
    activeTab(newVal) {
      console.log(newVal,45454)
      if (typeof newVal === 'number' && newVal >= 0 && newVal <= 3) {
        this.switchMainTab(newVal)
      }
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.login.userinfo
    }),
    titleTotalPages() { return Math.max(1, Math.ceil(this.titlePage.total / this.titlePage.limit)) },
    titlePages() { return this.pageNums(this.titlePage.page, this.titleTotalPages) },
    imgTotalPages() { return Math.max(1, Math.ceil(this.imgPage.total / this.imgPage.limit)) },
    imgPages() { return this.pageNums(this.imgPage.page, this.imgTotalPages) },
    detailTotalPages() { return Math.max(1, Math.ceil(this.detailPage.total / this.detailPage.limit)) },
    detailPages() { return this.pageNums(this.detailPage.page, this.detailTotalPages) },
    targetDirectionName() {
      return this.targetDirectionMap[this.targetDirection]
    },
    statusKey() {
      const keys = ['', 'is_image_white_bg', 'is_image_three_to_four', 'is_video']
      return keys[this.targetDirection]
    },
    imgCheckWays() {
      return [
        { label: '全部商品', value: 1 },
        { label: '未生成' + this.targetDirectionName, value: 2 },
        { label: '已生成' + this.targetDirectionName, value: 3 }
      ]
    },
    checkMap() {
      return this.arrayToObject(this.imgCheckWays)
    },
    skuStatusMap() {
      return this.arrayToObject(this.skuWays)
    },
    imgTaskStatusMap() {
      return this.arrayToObject(this.imgTaskStatusList)
    },
    detailStatusMap() {
      return this.arrayToObject(this.detailStatusList)
    },
    materialsMap(){
      const list = this.materialsList.concat({label: '全部主图', value: 0})
      return this.arrayToObject(list)
    },
    imgAllChecked(){
      return this.imgGoodsList.length > 0 && this.imgGoodsList.every(row => this.imgSelected.includes(row.product_id))
    }
  },
  created() {
    // 根据外部传入的 activeTab 切换到对应 tab
    if (typeof this.activeTab === 'number' && this.activeTab >= 0 && this.activeTab <= 3) {
      this.tab = this.activeTab
      this.switchMainTab(this.activeTab)
    }
    this.loadGroupList()
    this.getDictionaryWords()
    this.getTitleTaskList(1)
    this.getAIImgPowerFee()
    this.ismanager = (this.users && (this.users.mer_user_id === '1' || this.users.mer_user_id === '666'))
  },
  methods: {
    ...mapActions({
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      getCloudProductList: 'ucenter/getCloudProductList',
      opGetAIReplaceTitleList: 'ucenter/opGetAIReplaceTitleList',
      opGetAIReplaceTitleDetail: 'ucenter/opGetAIReplaceTitleDetail',
      opPostAIReplaceTitle: 'ucenter/opPostAIReplaceTitle',
      opPutAIReplaceTitle: 'ucenter/opPutAIReplaceTitle',
      opPutAIReplaceTitleDetail: 'ucenter/opPutAIReplaceTitleDetail',
      opUpdateAIReplaceBatchTitleDetail: 'ucenter/opUpdateAIReplaceBatchTitleDetail',
      opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
      opGetAIImgWhiteImg: 'ucenter/opGetAIImgWhiteImg',
      opGetAIImgGenerateTask: 'ucenter/opGetAIImgGenerateTask',
      opCreateAIImgGenerateTask: 'ucenter/opCreateAIImgGenerateTask',
      opCheckAIImgGeneratePower: 'ucenter/opCheckAIImgGeneratePower',
      opGetAIImgGenerateTaskDetail: 'ucenter/opGetAIImgGenerateTaskDetail',
      opPauseAIImgGenerateTask: 'ucenter/opPauseAIImgGenerateTask',
      opStartAIImgGenerateTask: 'ucenter/opStartAIImgGenerateTask',
      opCancelAIImgGenerateTask: 'ucenter/opCancelAIImgGenerateTask',
      opGetAIImgGeneratePowerFees: 'ucenter/opGetAIImgGeneratePowerFees',
    }),
    getAIImgPowerFee(){
      this.opGetAIImgGeneratePowerFees({
        data:{},
        success: (res) => {
          if(res.code === 200){
            let feeConfig = {}
            for(let item of res.data){
              feeConfig[item.type] = item.power_num
            }
            this.powerFee=feeConfig
          }

        }
      })
    },
    pageNums(page, total) {
      const nums = []
      const start = Math.max(1, Math.min(page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    arrayToObject(list) {
      const obj = {}
      for (const item of list) obj[item.value] = item
      return obj
    },
    loadGroupList() {
      if (this.groupList.length > 0) return
      this.groupLoading = true
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          this.groupLoading = false
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    switchMainTab(i) {
      this.tab = i
      if (i === 0) {
        this.switchTitleSub('task')
        this.getTitleTaskList(1)
      } else {
        this.targetDirection = i
        this.switchImgSub('goods')
      }
    },

    formatGroupName(row) {
      let group_id = row.import?.group_id || row.group_id || '-'
      let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
      let child_group_id = row.import?.child_group_id || row.child_group_id ||'-'
      const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
      const child_group_name = target?.name || null
      if(child_group_name) {
          group_name += '|'+child_group_name
      }
      return group_name;
  },
    // 商品来源平台 → 样式类（与 cloudLib 一致）
    sourceCls(v) {
      const map = {
        2: 'gx-opt__src--ali',
        3: 'gx-opt__src--tb',
        4: 'gx-opt__src--pdd',
        5: 'gx-opt__src--dy',
        6: 'gx-opt__src--wx',
        9: 'gx-opt__src--xhh'
      }
      return map[v] || 'gx-opt__src--other'
    },
    getGroupNameText(groupId, child_group_ids) {
      if (!groupId) return '全部'
      let ids = []
      if (typeof groupId === 'string') {
        try {
          ids = JSON.parse(groupId)
        } catch (e) {
          ids = groupId.split(',').map(item => item.trim())
        }
      } else {
        ids = Array.isArray(groupId) ? groupId : [groupId]
      }
      let childIds = []
      if (typeof child_group_ids === 'string') {
        try {
          childIds = JSON.parse(child_group_ids)
        } catch (e) {
          childIds = child_group_ids.split(',').map(item => item.trim())
        }
      } else {
        childIds = Array.isArray(child_group_ids) ? child_group_ids : (child_group_ids ? [child_group_ids] : [])
      }
      return ids.filter(id => id)
        .map(id => this.groupList.find(item => item.id === id))
        .filter(Boolean)
        .map(item => {
          let name = item.name
          if (item.child_groups && item.child_groups.length > 0 && childIds.length > 0) {
            const matchedChildNames = item.child_groups
              .filter(child => childIds.includes(child.id))
              .map(child => child.name)
            if (matchedChildNames.length > 0) {
              name += '（' + matchedChildNames.join('、') + '）'
            }
          }
          return name
        })
        .join('、')
    },
    /* ── AI标题 ── */
    switchTitleSub(sub) {
      this.titleSubTab = sub
      this.titlePage.page = 1
      this.titlePage.total = 0
      this.titleTaskSelected = []
      this.titleDetailSelected = []

      if (sub === 'task'){
          this.titleSearch.taskNo = ''
          this.getTitleTaskList(1)
      } else{
        this.getTitleDetailList(1)
      }
    },
    onTitlePageSizeChange(size) {
      this.titlePage.limit = size
      this.titlePage.page = 1
      this.getTitleTaskList(1)
    },
    onImgPageSizeChange(size) {
      this.imgPage.limit = size
      this.imgPage.page = 1
      this.getImgGoodsList(1)
    },
    getTitleTaskList(page) {
      this.titlePage.page = page
      const params = { page_size: this.titlePage.limit, page: this.titlePage.page, ...this.titleSearch }
      if (params.status === '') delete params.status
      if (params.taskNo === '') delete params.taskNo
      if (params.sku_status === '') delete params.sku_status
      if (!params.group_ids || !params.group_ids.length) delete params.group_ids
      if (!params.child_group_ids || !params.child_group_ids.length) delete params.child_group_ids
      this.loadingStart()
      this.opGetAIReplaceTitleList({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.titleTaskList = res.data.list || []
            this.titlePage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    getTitleDetailList(page) {
      this.titlePage.page = page
      const params = { page_size: this.titlePage.limit, page: this.titlePage.page, ...this.titleSearch }
      if (params.status === '') delete params.status
      if (params.taskNo === '') delete params.taskNo
      if (params.sku_status === '') delete params.sku_status
      if (!params.group_ids || !params.group_ids.length) delete params.group_ids
      if (!params.child_group_ids || !params.child_group_ids.length) delete params.child_group_ids
      this.loadingStart()
      this.opGetAIReplaceTitleDetail({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.titleDetailList = (res.data.list || []).map(row => {
              this.$set(row, 'edit_title', row.update_title || row.new_title || row.title)
              return row
            })
            this.titlePage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleTitleSearch() {
      this.titlePage.page = 1
      if (this.titleSubTab === 'task') this.getTitleTaskList(1)
      else this.getTitleDetailList(1)
    },
    refreshTitle() {
      this.titlePage.page = 1
      this.titlePage.total = 0
      this.titleChildGroupList = []
      this.titleSearch = { status: '', taskNo: '', sku_status: '', group_ids: [], child_group_ids: [] }
      this.handleTitleSearch()
    },
    changeTitleGroupIds() {
      this.$set(this.titleSearch, 'child_group_ids', [])
      this.titleChildGroupList = this.groupList.filter(i => this.titleSearch.group_ids.includes(i.id)).map(i => i.child_groups || []).flat()
      this.handleTitleSearch()
    },
    toggleTaskSel(row) {
      const idx = this.titleTaskSelected.indexOf(row)
      if (idx > -1) this.titleTaskSelected.splice(idx, 1)
      else this.titleTaskSelected.push(row)
    },
    toggleDetailSel(row) {
      const idx = this.titleDetailSelected.indexOf(row)
      if (idx > -1) this.titleDetailSelected.splice(idx, 1)
      else this.titleDetailSelected.push(row)
    },
    handleView(row) {
      this.titleSubTab = 'detail'
      this.titlePage.page = 1
      this.titlePage.total = 0
      this.titleSearch = { status: '', sku_status: '', group_ids: [], child_group_ids: [], taskNo: row.task_no || '' }
      this.getTitleDetailList(1)
    },
    handleStop(row) {
      this.$confirm(`是否停止${row.task_no}任务，标题已提交AI的链接会继续执行。`, '提示', { type: 'warning' }).then(() => {
        this.opPutAIReplaceTitle({
          data: row.id,
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.titlePage.page = 1
            this.titlePage.total = 0
            this.titleSearch = { status: '', taskNo: '', sku_status: '', group_ids: [], child_group_ids: [] }
            this.getTitleTaskList(1)
          }
        })
      }).catch(() => {})
    },
    handleCheck() {
      this.titleChildGroupList = []
      this.titleFormChildGroupList = []
      this.aiTitleFormShow = true
      this.aiTitleForm = { group_ids: [], child_group_ids: [], lexicon_types: [], data_method: 1, ai_method: 1, sku_status: '' }
    },
    changeTitleFormGroupIds() {
      this.$set(this.aiTitleForm, 'child_group_ids', [])
      this.titleFormChildGroupList = this.groupList.filter(i => this.aiTitleForm.group_ids.includes(i.id)).map(i => i.child_groups || []).flat()
    },
    submitForm() {
      if (!this.aiTitleForm.data_method) {
        this.$message.error('请选择需要生成标题商品')
        return
      }
      this.submitFormLoading = true
      this.opPostAIReplaceTitle({
        data: this.aiTitleForm,
        success: (res) => {
          this.submitFormLoading = false
          if (res.code === 200) {
            this.aiTitleFormShow = false
            this.$message.success(res.message)
            this.getTitleTaskList(1)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleUpdate(row) {
      if (row.status === 1 || row.status === 2) {
        this.$message.error('待处理和处理中的状态无法替换标题!')
        return
      }
      this.aiTitleUpdateShow = true
      this.aiTitleUpdateForm = { id: row.id, old_word: '', new_word: '', before_word: '', after_word: '' }
    },
    submitUpdateForm() {
      if (!this.aiTitleUpdateForm.old_word) {
        this.$message.error('请输入待替换词')
        return
      }
      if (!this.aiTitleUpdateForm.new_word) {
        this.$message.error('请输入替换词')
        return
      }
      if (!this.aiTitleUpdateForm.id) {
        this.$message.error('请选择批次')
        return
      }
      const splitWords = (str) => {
        return str.replace(/，/g, ',').split(',').map(i => i.trim()).filter(Boolean)
      }
      const oldArr = splitWords(this.aiTitleUpdateForm.old_word)
      const newArr = splitWords(this.aiTitleUpdateForm.new_word)
      if (oldArr.length !== newArr.length) {
        this.$message.error('待替换词与替换词的数量不匹配，请保持一致！')
        return
      }
      this.aiTitleUpdateLoading = true
      this.opUpdateAIReplaceBatchTitleDetail({
        data: {
          id: this.aiTitleUpdateForm.id,
          old_word: oldArr,
          new_word: newArr,
          before_word: this.aiTitleUpdateForm.before_word,
          after_word: this.aiTitleUpdateForm.after_word
        },
        success: (res) => {
          this.aiTitleUpdateLoading = false
          if (res.code === 200) {
            this.aiTitleUpdateShow = false
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    saveEditTitle(row) {
      if (!row.id) {
        this.$message.warning('id不能为空')
        return
      }
      const title = (row.edit_title || '').trim()
      if (!title) {
        this.$message.warning('请输入新标题')
        return
      }
      const len = title.replace(/[^\x00-\xff]/g, 'xx').length
      if (len < 8) {
        this.$message.warning('商品名称最少需要输入 4 个汉字（8个字符）')
        return
      }
      if (len > 60) {
        this.$message.warning('商品名称最多只能输入 30 个汉字（60个字符）')
        return
      }
      this.aiTitleUpdateLoading = true
      this.opPutAIReplaceTitleDetail({
        id: row.id,
        data: { id: row.id, title },
        success: (res) => {
          this.aiTitleUpdateLoading = false
          if (res.code === 200) {
            row.update_title = title
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    getDictionaryWords() {
      this.opGetDictionaryWords({
        data: { dictionary_type: 1 },
        success: (res) => {
          if (res.code === 200) {
            const list = res.data || []
            list.sort((a, b) => (a.merchant_id === 0 ? -1 : 0))
            this.dictionaryWordsList = list
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /* ── AI图片 ── */
    switchImgSub(sub) {
      this.imgSubTab = sub
      this.imgPage.page = 1
      this.imgPage.total = 0
      this.imgSelected = []
      if (sub === 'goods') {
        this.imgSearch = { status: 1, sku_status: '', group_id: '', child_group_id: '' }
        this.$set(this.imgSearch, this.statusKey, '')
        this.getImgGoodsList(1)
      } else {
        this.imgTaskSearch = {
          status: '', task_no: '', target_direction: this.targetDirection, process_direction: '', sku_status: '', create_time: ''
        }
        this.getImgTaskList(1)
      }
    },
    getImgGoodsList(page) {
      this.imgPage.page = page
      const params = { page_size: this.imgPage.limit, page: this.imgPage.page, ...this.imgSearch }
      if (params.status === '') delete params.status
      if (params.sku_status === '') delete params.sku_status
      if (params.group_id === '') delete params.group_id
      if (params.child_group_id === '') delete params.child_group_id
      if (params[this.statusKey] === '') delete params[this.statusKey]
      this.loadingStart()
      this.getCloudProductList({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.imgGoodsList = res.data.list || []
            this.imgPage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    getImgTaskList(page) {
      this.imgPage.page = page
      const params = { page_size: this.imgPage.limit, page: this.imgPage.page, ...this.imgTaskSearch }
      if (params.status === '') delete params.status
      if (params.task_no === '') delete params.task_no
      if (params.process_direction === '') delete params.process_direction
      if (params.sku_status === '') delete params.sku_status
      if(params.create_time && params.create_time.length > 0){
        params.created_at = [params.create_time[0], params.create_time[1]]
      }
      // if (params.start_time) params.created_at_start = params.start_time
      // if (params.end_time) params.created_at_end = params.end_time
      delete params.create_time
      this.loadingStart()
      this.opGetAIImgGenerateTask({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.imgTaskList = res.data.list || []
            this.imgPage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleImgSearch() {
      this.imgPage.page = 1
      if (this.imgSubTab === 'goods') this.getImgGoodsList(1)
      else this.getImgTaskList(1)
    },
    refreshImg() {
      this.imgPage.page = 1
      this.imgPage.total = 0
      this.imgChildGroupList = []
      if (this.imgSubTab === 'goods') {
        this.imgSearch = { status: 1, sku_status: '', group_id: '', child_group_id: '' }
        this.$set(this.imgSearch, this.statusKey, '')
        this.getImgGoodsList(1)
      } else {
        this.imgTaskSearch = {
          status: '', task_no: '', target_direction: this.targetDirection, process_direction: '', sku_status: '', create_time: []
        }
        this.getImgTaskList(1)
      }
    },
    changeImgGroupId() {
      this.$set(this.imgSearch, 'child_group_id', '')
      this.imgChildGroupList = this.groupList.filter(i => i.id == this.imgSearch.group_id).map(i => i.child_groups || []).flat()
      this.handleImgSearch()
    },
    changeImgFormGroupIds(val) {
      this.$set(this.aiForm, 'child_group_ids', [])
      this.imgFormChildGroupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
    },
    toggleImgSel(row) {
      const idx = this.imgSelected.indexOf(row)
      if (idx > -1) this.imgSelected.splice(idx, 1)
      else this.imgSelected.push(row)
    },
    toggleImgAll() {
      if(this.imgSelected.length<this.imgGoodsList.length){
        this.imgSelected=this.imgGoodsList.map(i => i.product_id)
      }else{
        this.imgSelected =[]
      }
    },
    getImageStatusText(row) {
      const val = row[this.statusKey]
      if (val === 1) return '未生成'
      if (val === 2) return '生成中'
      if (val === 3) {
        if (this.isImageExpire(row)) return '已过期'
        return '已生成'
      }
      return '未知'
    },
    isImageExpire(row) {
      const atKeys = ['', 'image_white_at', 'image_three_to_four_at', 'video_at']
      const at = row[atKeys[this.targetDirection]]
      if (!at) return true
      const createTime = new Date(at)
      const expireTime = createTime.getTime() + 90 * 24 * 60 * 60 * 1000
      return expireTime < Date.now()
    },
    imgStatusCls(row) {
      const val = row[this.statusKey]
      if (val === 1) return 'gx-opt__img-status--1'
      if (val === 2) return 'gx-opt__img-status--2'
      if (val === 3) return this.isImageExpire(row) ? 'gx-opt__img-status--expire' : 'gx-opt__img-status--3'
      return ''
    },
    handleImgCheck() {
      this.imgFormChildGroupList = []
      this.aiFormShow = true
      this.aiForm = {
        group_ids: [],
        child_group_ids: [],
        product_ids: [],
        sku_status: '',
        process_direction: '',
        target_direction: this.targetDirection,
        target_quantity: ''
      }
      if(this.targetDirection===1){
        this.$set(this.aiForm, 'specify_materials', 9)
      }
    },
    checkTaskPower() {
      if (!this.aiForm.process_direction) {
        this.$message.error('请选择需要生成图片商品')
        return
      }
      this.submitFormLoading = true
      const params = { ...this.aiForm }
      if (this.imgSelected.length) {
        params.product_ids = this.imgSelected
      }
      this.opCheckAIImgGeneratePower({
        data: params,
        success: (res) => {
          this.submitFormLoading = false
          if (res.code === 200) {
            this.powerInfo = res.data
            this.powerShow = true
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    submitImgForm() {
      this.checkFormLoading = true
      const params = { ...this.aiForm }
      if (this.imgSelected.length) {
        params.product_ids = this.imgSelected.map(item => item.product_id)
      }
      this.opCreateAIImgGenerateTask({
        data: params,
        success: (res) => {
          this.checkFormLoading = false
          if (res.code === 200) {
            this.powerShow = false
            this.aiFormShow = false
            this.$message.success(res.message)
            this.getImgTaskList(1)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleViewImg(row) {
      this.opGetAIImgWhiteImg({
        data: { product_id: row.product_id, type: this.targetDirection },
        success: (res) => {
          if (res.code === 200) {
            if (res.data && res.data.length > 0 && res.data[0]) {
              if (this.targetDirection === 3) {
                this.previewVideo(res.data)
              } else {
                this.previewImage(res.data)
              }
            } else {
              this.$message.error(this.targetDirection === 3 ? '未查询到视频' : '未查询到图片')
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleEdit(row) {
      this.cloudEditMode = 'single'
      this.cloudEditList = [row]
      this.cloudEditSourceList = [row]
      this.cloudEditShow = true
    },

    handleCancel(row) {
      this.$confirm(`确定要取消任务【${row.task_no}】吗？`, '提示', { type: 'warning' }).then(() => {
        this.opCancelAIImgGenerateTask({
          data: { id: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('取消成功')
              this.getImgTaskList(this.imgPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handleStart(row) {
      this.$confirm(`确定要启动任务【${row.task_no}】吗？`, '提示', { type: 'warning' }).then(() => {
        this.opStartAIImgGenerateTask({
          data: { id: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('启动成功')
              this.getImgTaskList(this.imgPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handlePause(row) {
      this.$confirm(`确定要暂停任务【${row.task_no}】吗？`, '提示', { type: 'warning' }).then(() => {
        this.opPauseAIImgGenerateTask({
          data: { id: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('暂停成功')
              this.getImgTaskList(this.imgPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    /* ── 任务详情 ── */
    handleViewTask(row) {
      this.detailSearchParams = {
        task_id: row.id,
        task_no: row.task_no,
        product_id: '',
        status: '',
        create_time: []
      }
      this.taskDetailShow = true
      this.refreshDetail()
    },
    refreshDetail() {
      this.detailSearchParams.product_id = ''
      this.detailSearchParams.status = ''
      this.detailSearchParams.create_time = []
      this.handleSearchDetail()
    },
    handleSearchDetail() {
      this.detailPage.page = 1
      this.getTaskDetailList(1)
    },
    getTaskDetailList(page) {
      this.detailPage.page = page
      const params = { page: this.detailPage.page, page_size: this.detailPage.limit, ...this.detailSearchParams }
      if (params.status === '') delete params.status
      if (params.product_id === '') delete params.product_id
      if(params.create_time && params.create_time.length){
           params.created_at = [params.create_time[0], params.create_time[1]]
      }
      delete params.create_time
      this.opGetAIImgGenerateTaskDetail({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.detailTableData = res.data.list || []
            this.detailPage.total = res.data.total || 0
            this.detailStatistics = res.data.statistics || {}
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    previewProcessed(row) {
      if (this.targetDirection === 3) {
        this.previewVideo(row.processed_contents || [])
      } else {
        this.previewImage(row.processed_contents || [])
      }
    },
    /* ── 预览 ── */
    previewImage(images) {
      images = images || []
      if (!images.length) {
        this.$message.warning('暂无可预览的图片')
        return
      }
      if (images.length > 1) {
        this.imageUrlList = images
        this.imagesShow = true
        this.isEffectImg = true
      } else {
        this.previewSingle(images[0])
      }
    },
    previewSingle(url) {
      this.singleImgUrl = url
      this.singleImgShow = true
    },
    previewVideo(urls) {
      if (!urls || urls.length === 0) {
        this.$message.warning('暂无可预览的视频')
        return
      }
      this.videoUrl = urls[0]
      this.videoPreviewShow = true
    },
    handleVideoError() {
      this.$message.error('视频加载失败，请稍后重试')
    },
    /* ── 状态样式 ── */
    titleStatusStyle(status) {
      const map = {
        1: ['#FA8C16', '#FDF6EC', '#F5DAB1'],
        2: ['#409EFF', '#ECF5FF', '#A9CBFF'],
        3: ['#52C41A', '#F0F9EB', '#B3E19D'],
        4: ['#909399', '#F4F5F7', '#E4E7ED'],
        9: ['#C8443C', '#FFF1F0', '#FFCCC7']
      }
      const [color, bg, border] = map[status] || ['#909399', '#F4F5F7', '#E4E7ED']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    imgTaskStatusStyle(status) {
      const map = {
        1: ['#FA8C16', '#FDF6EC', '#F5DAB1'],
        2: ['#409EFF', '#ECF5FF', '#A9CBFF'],
        3: ['#52C41A', '#F0F9EB', '#B3E19D'],
        4: ['#909399', '#F4F5F7', '#E4E7ED'],
        5: ['#8B5CF6', '#F6F2FE', '#D3C2F9'],
        9: ['#C8443C', '#FFF1F0', '#FFCCC7']
      }
      const [color, bg, border] = map[status] || ['#909399', '#F4F5F7', '#E4E7ED']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    imgTaskSkuStatusStyle(status) {
      const map = {
        1: ['#FA8C16', '#FDF6EC', '#F5DAB1'],
        2: ['#52C41A', '#F0F9EB', '#B3E19D'],
        3: ['#C8443C', '#FFF1F0', '#FFCCC7']
      }
      const [color, bg, border] = map[status] || ['#909399', '#F4F5F7', '#E4E7ED']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    detailStatusStyle(status) {
      const map = {
        1: ['#FA8C16', '#FDF6EC', '#F5DAB1'],
        2: ['#409EFF', '#ECF5FF', '#A9CBFF'],
        3: ['#52C41A', '#F0F9EB', '#B3E19D'],
        4: ['#909399', '#F4F5F7', '#E4E7ED'],
        5: ['#C8443C', '#FFF1F0', '#FFCCC7']
      }
      const [color, bg, border] = map[status] || ['#909399', '#F4F5F7', '#E4E7ED']
      return { color, background: bg, border: `1px solid ${border}` }
    }
  }
}
</script>
<style scoped>
.gx-opt__layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.gx-opt__sider {
  width: 196px;
  flex-shrink: 0;
  align-self: stretch;
  min-height: calc(100vh - 100px);
}
.gx-opt__main {
  flex: 1;
  min-width: 0;
}
.gx-opt__tabs {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #FFFFFF;
  border: 1px solid #EBEEF5;
  border-radius: 10px;
  padding: 8px;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}
.gx-opt__tab {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 12px;
  border: none;
  cursor: pointer;
  background: transparent;
  font-size: 13px;
  color: #606266;
  text-align: left;
  transition: all .15s;
  font-weight: 500;
  border-radius: 8px;
  position: relative;
}
.gx-opt__tab-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: #F4F5F7; */
  border-radius: 6px;
  font-size: 15px;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-opt__tab-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.gx-opt__tab-name {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-opt__tab-desc {
  font-size: 11px;
  line-height: 1.4;
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-opt__tab:hover {
  background: #FFF5F4;
  color: #C8443C;
}
.gx-opt__tab:hover .gx-opt__tab-icon {
  /* background: #FFE6E2; */
}
.gx-opt__tab:hover .gx-opt__tab-desc {
  color: #C8443C;
}
.gx-opt__tab--on {
  background: linear-gradient(135deg, #FFE6E2 0%, #FFF0EB 100%);
  color: #C8443C;
  font-weight: 600;
}
.gx-opt__tab--on .gx-opt__tab-icon {
  /* background: linear-gradient(135deg, #E85D4E, #F47B5A); */
  color: #FFFFFF;
  /* box-shadow: 0 2px 4px rgba(232, 93, 78, .28); */
}
.gx-opt__tab--on .gx-opt__tab-desc {
  color: #C8443C;
}
.gx-opt__pane-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px 10px 22px;
  border-radius: 8px;
  background: #F5F0E8;
  border: 2px solid #E0E0EC;
  margin-bottom: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  position: relative;
}
.gx-opt__pane-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
  line-height: 1;
}
.gx-opt__pane-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.gx-opt__pane-title {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
  line-height: 1.4;
}
.gx-opt__pane-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.gx-opt__seg {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}
.gx-opt__seg-btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  background: #FFFFFF;
  cursor: pointer;
  font-size: 12px;
  color: #606266;
  transition: all .15s ease;
  font-weight: 500;
}
/* .gx-opt__seg-btn:hover {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
} */
.gx-opt__seg-btn--on {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  border-color: transparent;
  color: #FFFFFF;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(232, 93, 78, .28);
}
.gx-opt__btn {
  height: 32px;
  padding: 0 13px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  transition: all .15s ease;
}
.gx-opt__btn:hover:not(:disabled) {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-opt__btn--primary {
  color: #FFFFFF;
  box-shadow: 0 2px 4px rgba(232, 93, 78, .25);
  font-size: 13px;
  font-weight: 600;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  border: none;
}
.gx-opt__btn--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  color: #FFFFFF;
  box-shadow: 0 3px 8px rgba(232, 93, 78, .35);
}
.gx-opt__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-opt__filter {
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 14px;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  display: flex;
  gap: 10px 14px;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.gx-opt__fitem {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-opt__flabel {
  font-size: 12px;
  color: #606266;
  white-space: nowrap;
  font-weight: 500;
}
.gx-opt__fitem--btns {
  margin-left: auto;
}
.gx-opt__input {
  width: 140px;
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #303133;
  outline: none;
  box-sizing: border-box;
  transition: border-color .15s ease;
}
.gx-opt__input:focus {
  border-color: #C8443C;
}
.gx-opt__input--full {
  width: 100%;
}
.gx-opt__input--flex {
  flex: 1;
  min-width: 160px;
  max-width: 420px;
}
.gx-opt__input--date {
  width: 170px;
}
.gx-opt__range-sep {
  color: #909399;
  font-size: 12px;
}
.gx-opt__select {
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  background: #FFFFFF;
  font-size: 12px;
  color: #303133;
  outline: none;
  min-width: 120px;
  transition: border-color .15s ease;
}
.gx-opt__select:focus {
  border-color: #C8443C;
}
.gx-opt__select--full {
  width: 100%;
  min-width: 0;
}
.gx-opt__actionrow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  background: linear-gradient(180deg, #FFFBF5 0%, #FFF8EF 100%);
  border: 1px solid #FFE7D1;
  border-radius: 10px;
  margin-bottom: 14px;
  flex-wrap: wrap;
  box-shadow: 0 2px 4px rgba(232, 93, 78, .04);
}
.gx-opt__info-icon {
  color: #909399;
  cursor: help;
  font-size: 16px;
}
.gx-opt__table {
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid #F0F0F0;
  border-bottom: none;
  margin-bottom: 0;
  background: #FFFFFF;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.gx-opt__table--plain {
  border: 1px solid #EBEEF5;
}
.gx-opt__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-opt__table thead {
  position: sticky;
  top: 0;
}
.gx-opt__table th {
  padding: 11px 14px;
  text-align: left;
  background: #FAF6EE;
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  letter-spacing: .02em;
  white-space: nowrap;
  border-bottom: 1px solid #EBEEF5;
}
.gx-opt__table td {
  padding: 12px 14px;
  font-size: 12px;
  color: #303133;
  border-top: 1px solid #EBEEF5;
  vertical-align: center;
}
.gx-opt__check {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .15s ease;
}
.gx-opt__check:hover {
  border-color: #C8443C;
}
.gx-opt__check--on {
  background: #C8443C;
  border-color: #C8443C;
  box-shadow: 0 1px 3px rgba(200, 68, 60, 0.18);
}
.gx-opt__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-opt__dim {
  color: rgb(153, 153, 153)!important;
}
.gx-opt__gold {
  color: #E8C778;
  font-weight: 600;
}
.gx-opt__warn {
  margin-right: auto;
  font-size: 12px;
  color: #F87171;
}
.gx-opt__req {
  color: #F87171;
  font-style: normal;
}
.gx-opt__status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: rgba(139, 157, 195, .1);
  border: 1px solid rgba(139, 157, 195, .3);
  color: #6A6A8A;
  white-space: nowrap;
  display: inline-block;
}
.gx-opt__statuscell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.gx-opt__err {
  font-size: 11px;
  color: #F87171;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-opt__goods {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  min-width: 260px;
}
.gx-opt__thumb {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(135deg, #E1E5EE, #FFFFFF);
  border: 1px solid rgba(212, 169, 70, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-opt__thumb--sm {
  width: 44px;
  height: 44px;
  cursor: pointer;
}
.gx-opt__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-opt__goods-body {
  min-width: 0;
  flex: 1;
}
.gx-opt__line {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 1.6;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.gx-opt__label {
  color: #6A6A8A;
  flex-shrink: 0;
  font-size: 12px;
  margin-bottom: 8px;
}
.gx-opt__txt {
  color: #303133;
  word-break: break-all;
  min-width: 0;
}
.gx-opt__txt--ai {
  color:#8B5CF6;
  font-weight: 500;
}
.gx-opt__group {
  font-size: 12px;
  color: #303133;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}
.gx-opt__src {
  display: inline-block;
  width: fit-content;
  text-align: center;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #E4E7ED;
  background: #F4F5F7;
  font-size: 11px;
  color: #909399;
/*  height: 22px;
  line-height: 22px;*/
}
.gx-opt__src--ali {
  background: #FBF3DF;
  border-color: #EFD49A;
  color: #C9962B;
}
.gx-opt__src--tb {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-opt__src--pdd {
  background: #FFF3E8;
  border-color: #FFC9A8;
  color: #E8742C;
}
.gx-opt__src--dy {
  background: #F0F1F5;
  border-color: #D0D4E0;
  color: #3A3A52;
}
.gx-opt__src--wx {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #67C23A;
}
.gx-opt__src--xhh {
  background: #ECF5FF;
  border-color: #B3D8FF;
  color: #409EFF;
}
.gx-opt__img-status {
  display: inline-block;
  min-width: 38px;
  text-align: center;
  padding: 2px 7px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
}
.gx-opt__img-status--1 {
  background: #E6F4FF;
  border: 1px solid #91CAFF;
  color: #409EFF;
}
.gx-opt__img-status--2 {
  background: #F0F9EB;
  border: 1px solid #B3E19D;
  color: #67C23A;
}
.gx-opt__img-status--3 {
  background: #F0F9EB;
  border: 1px solid #B3E19D;
  color: #67C23A;
}
.gx-opt__img-status--expire {
  background: #4A4A6A;
  border: 1px solid #4A4A6A;
  color: #fff;
}
.gx-opt__counts {
  font-size: 11px;
  line-height: 1.7;
  white-space: nowrap;
}
.gx-opt__counts b {
  color: #303133;
}
.gx-opt__ok {
  color: #67C23A;
  font-weight: 600;
}
.gx-opt__fail {
  color: #C8443C;
  font-weight: 600;
}
.gx-opt__time {
  font-size: 11px;
  color: rgb(153, 153, 153)!important;
  line-height: 1.7;
  white-space: nowrap;
}
.gx-opt__ops {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  max-width: 220px;
}
.gx-opt__op {
  height: 26px;
  padding: 0 8px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  color: #606266;
  white-space: nowrap;
  transition: all .15s ease;
  font-weight: 500;
}
.gx-opt__op:hover:not(:disabled) {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-opt__op:disabled {
  color: #C0C4CC;
  cursor: not-allowed;
}
.gx-opt__op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-opt__op--edit:hover {
  background: #D6EFFF;
  border-color: #69B1FF;
  color: #1677FF;
}
.gx-opt__op--primary {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-opt__op--primary:hover:not(:disabled) {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
.gx-opt__op--danger {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #F56C6C;
}
.gx-opt__op--danger:hover {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #F56C6C;
}
.gx-opt__op--recover {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #67C23A;
}
.gx-opt__op--recover:hover {
  background: #E1F3D8;
  color: #67C23A;
}
.gx-opt__empty {
  text-align: center;
  padding: 60px 0 !important;
  color: #909399;
  font-size: 13px;
}
.gx-opt__empty::before {
  content: '📭';
  display: block;
  font-size: 36px;
  margin-bottom: 8px;
  opacity: .55;
}
.gx-opt__pager {
  padding: 10px 14px;
  background: rgb(245, 240, 232);
}

.gx-opt__stats {
  font-size: 13px;
  color: #606266;
  margin-bottom: 10px;
}
.gx-opt__stats b {
  color: #303133;
}
.gx-opt__modal {
  position: fixed;
  inset: 0;
  z-index: 750;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-opt__modal--wide {
  z-index: 720;
}
.gx-opt__modal-box {
  width: 100%;
  max-width: 520px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 20px 56px rgba(15, 23, 42, .18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.gx-opt__modal-box--sm {
  max-width: 440px;
}
.gx-opt__modal-box--lg {
  max-width: 680px;
}
.gx-opt__modal-box--xl {
  max-width: 1000px;
}
.gx-opt__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  flex-shrink: 0;
  background: rgb(245, 240, 232);
}
.gx-opt__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
  padding-left: 10px;
  position: relative; /* 必须加，让伪元素相对父元素定位 */
}
.gx-opt__modal-title::before{
      width: 3px;
      height: 15px;
      border-radius: 2px;
      background: rgb(200, 68, 60);
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      content: '';
}
.gx-opt__modal-close {
      width: 26px;
    height: 26px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(255, 255, 255);
    border: 2px solid rgb(224, 224, 236);
    cursor: pointer;
}
.gx-opt__modal-close:hover {
  color: #C8443C;
}
.gx-opt__modal-body {
  padding: 18px 20px;
  overflow-y: auto;
}
.gx-opt__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  flex-shrink: 0;
  align-items: center;
  background: #FFFFFF;
}
.gx-opt__field {
  margin-bottom: 14px;
}
.gx-opt__label {
  display: block;
  font-size: 12px;
  color: #606266;
  /* margin-bottom: 6px; */
  font-weight: 500;
}
.gx-opt__power-row {
  font-size: 14px;
  margin-bottom: 10px;
}
.gx-opt__tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
}
.gx-opt__tag--ok {
  background: #F0F9EB;
  border: 1px solid #B3E19D;
  color: #67C23A;
}
.gx-opt__tag--fail {
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  color: #C8443C;
}
.gx-opt__img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 0;
}
.gx-opt__img-item {
  width: 110px;
  height: 110px;
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all .15s ease;
}
.gx-opt__img-item:hover {
  border-color: #C8443C;
  box-shadow: 0 2px 8px rgba(200, 68, 60, 0.15);
}
.gx-opt__img-item--34 {
  width: 82px;
  height: 110px;
}
.gx-opt__img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-opt__single-img {
  width: 100%;
  border-radius: 8px;
}
.gx-opt__video {
  display: block;
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}
.gx-cloud__gname--sub{
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}
</style>
<style scoped>
.radio-box{
 display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
:deep(.radio-box .el-radio__label){
  font-size: 12px;
}
.power-tip{
  font-size: 12px;
  color:#ff4545;
  line-height: 17px;
  margin-bottom: 14px;
}
.power-tip.m-t-10{
  margin-top: -10px;
}
.gx-opt__fee-tip{
  color: #B0B3BB;
  font-size: 13px;
  margin-left: 3px;
  cursor: help;
  font-style: normal;
}
.gx-opt__fee-tip:hover{
  color: #C8443C;
}
</style>
<style>
/* 算力问号提示（el-tooltip 挂载于 body，需非 scoped 样式） */
.gx-opt__fee-popper{
  white-space: pre-line;
  line-height: 1.7;
}
</style>
